import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState, IGDPRConsent } from '../../types/state.d';
import i18n from '../../i18next';
import logInfo from './logInfo';
import { getTeamGuid } from '../../selectors/apiSelectors';
import { getLocks } from '../../selectors/locksSelectors';

export const fetchGDPRConsents = () => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.FETCH_GDPR_CONSENTS;
  const frpLocationId = 2;
  const locale = i18n.language;

  await auth.refreshAccessTokenIfExpired();
  const accessToken = auth.getAccessToken();

  const teamGuid = getTeamGuid(getState());
  const locks = getLocks(getState());

  try {
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${
        config.preferenceServiceAPI
      }/consentstatements/${frpLocationId}/${locale}`,
      {
        credentials: 'same-origin',
      },
    );
    const loggingData = {
      frpLocationId,
      locale,
      teamGuid,
      userGuid: (accessToken && accessToken.guid) || null,
      locks,
    };
    if (response && !response.ok) {
      dispatch(
        logInfo({
          tags: ['api_failure'],
          message: ERROR_MESSAGES.FETCH_GDPR_CONSENTS,
          method: 'GET',
          body: loggingData,
          res: response.bodyUsed ? null : await response.json(),
        }),
      );
      throw new Error(ERROR_MESSAGES.FETCH_GDPR_CONSENTS);
    }
    const data: IGDPRConsent[] = await response.json();
    dispatch(apiActions.saveGDPRConsents(data));
    dispatch(httpActions.httpRequestSuccess(resourceName));

    dispatch(
      logInfo({
        tags: ['api_success'],
        message: 'success fetching gdpr consents',
        method: 'GET',
        body: {
          ...loggingData,
          data,
        },
        res: data,
      }),
    );
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
  }
};

export default fetchGDPRConsents;
